import _pickby from 'lodash/pickBy';

export function cleanObject(obj: {}) {
  return _pickby<string>(obj, function (value, key) {
    return !(value === undefined || value === null);
  });
}
export const isNull = (value: any) => value === null;

export const isAdminSite = () => {
  const regex = /^(dashboard|admin([0-9]+)?)\.[0-9a-z].*/gm;
  return !isNull(regex.exec(window.location.host));
};

export const hideSplashScreen = () => {
  const splashScreenDomNode = document.getElementById('splash-screen') as HTMLElement;
  if (splashScreenDomNode instanceof HTMLElement) {
    splashScreenDomNode.style.display = 'none';
  }
};

export const isShareableRoute = () => !!window?.location?.pathname.startsWith('/sh');

export const inFrame = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return false;
  }
};

export const isExternalRoute = () => window.location.pathname.startsWith('/sh/');

export const setCookie = (cname: string, cvalue: string | undefined, exdays = 10000) => {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = 'expires=' + d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/; SameSite=None; Secure;';
};

export const removeCookie = (name: string, domain?: string, path: string = '/') => {
  try {
    let cookieString = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path};`;
    if (domain) {
      cookieString += ` domain=${domain};`;
    }
    document.cookie = cookieString;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Error removing cookie:', e);
  }
};
